import React from 'react';

export default ({ color = '#221CB6', size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 2.25H2.25"
      stroke={color}
      strokeWidth="1.96364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 6.75H2.25"
      stroke={color}
      strokeWidth="1.96364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 11.25H2.25"
      stroke={color}
      strokeWidth="1.96364"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.625 12.374L13.5 9.74902L12.375 12.374L9.75 13.499L12.375 14.624L13.5 17.249L14.625 14.624L17.25 13.499L14.625 12.374Z"
      fill={color}
    />
  </svg>
);
